export const UNTRUSTED_KERNEL_DATA_BEGIN = "<<<UNTRUSTED_KERNEL_DATA_JSON>>>";
export const UNTRUSTED_KERNEL_DATA_END = "<<<END_UNTRUSTED_KERNEL_DATA_JSON>>>";

// JSON provides the structural boundary here: embedded newlines, quotes, and
// marker-looking text remain escaped string data rather than becoming prompt
// sections of their own. Callers must still tell the receiving agent that the
// envelope is inert data, not instructions.
export function serializeUntrustedKernelData(value) {
    const json = JSON.stringify(value, null, 2) ?? "null";
    return [
        UNTRUSTED_KERNEL_DATA_BEGIN,
        json,
        UNTRUSTED_KERNEL_DATA_END,
    ].join("\n");
}
